<div class="maintenance-div">
  <div class="text-center forbidden-content" *ngIf="hasManagerPermission">
    <img class="permission-icon" src="assets/images/permission-manager.svg" />
    <br/>
    <br/>
    <h1>
      {{ Localization.ForbiddenHeader | translate}}
    </h1>
    <br />
    <h3>{{ Localization.ForbiddenDetails | translate}}</h3>
    <br />
  </div>
  <div class="text-center forbidden-content" *ngIf="!hasManagerPermission">
    <img class="permission-icon" src="assets/images/permission-app.svg" />
    <br/>
    <br/>
    <h1>
      {{ Localization.ForbiddenManagerRequiredHeader | translate}}
    </h1>
    <br/>
    <h3 [innerHTML]="Localization.ForbiddenManagerRequiredDetails | translate">
    </h3>
  </div>
</div>
